import React from 'react';
import { ErrorGoToHomepage } from './ui/ErrorLoadingPage';

function Error() {
  return <ErrorGoToHomepage />;
}

export default Error;
